function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon/Link/M/Default"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8,12 C8,12.5522847 8.44771525,13 9,13 L15,13 C15.5522847,13 16,12.5522847 16,12 C16,11.4477153 15.5522847,11 15,11 L9,11 C8.44771525,11 8,11.4477153 8,12 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9,16 L7.21,16 C5.08050201,16.0568407 3.25714183,14.4846798 3,12.37 C2.89563037,11.2466297 3.27051545,10.1314221 4.03226967,9.29920564 C4.79402388,8.46698916 5.87180217,7.99516205 7,8 L9,8 C9.55228475,8 10,7.55228475 10,7 C10,6.44771525 9.55228475,6 9,6 L7.21,6 C4.14527862,5.95904517 1.51819715,8.18097609 1.05,11.21 C0.82229178,12.9243723 1.34540139,14.6536239 2.48518712,15.9543206 C3.62497285,17.2550172 5.27057151,18.0006444 7,18.0000004 L9,18.0000004 C9.55228475,18.0000004 10,17.5522847 10,17 C10,16.4477153 9.55228475,16 9,16 L9,16 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23,11.24 C22.5373142,8.17062838 19.8631431,5.92501028 16.76,6 L15.25,6 C14.44,6 14,6.45 14,7 C14,7.55228475 14.4477153,8 15,8 L16.79,8 C18.919498,7.94315929 20.7428582,9.5153202 21,11.63 C21.1043696,12.7533703 20.7294845,13.8685779 19.9677303,14.7007944 C19.2059761,15.5330108 18.1281978,16.0048379 17,16 L15,16 C14.4477153,16 14,16.4477153 14,17 C14,17.5522847 14.4477153,18 15,18 L17,18 C18.7321743,18.0139597 20.3858581,17.2786114 21.5357375,15.9830806 C22.6856169,14.6875498 23.2194721,12.9582709 23,11.24 Z",
  id: "Path",
  fill: "#000000",
  fillRule: "nonzero"
}));

function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon_link.7bd73e44.svg";
export { ForwardRef as ReactComponent };